module.exports = __webpack_public_path__ + "img/Bronze Award 2025.e7ec3a0a.png";